var Vendd = (function (Vendd) {
    'use strict';

    Vendd.MessageBus.subscribe(Vendd.Loyalty.Messages.GetLoyaltyNewsDetail, Vendd.Loyalty, function (envelope) {

        var options = {
            method: 'POST',
            url: 'api/LoyaltyNews/GetLoyaltyNewsDetail',
            data: envelope.message.data,
            onSuccess: onSuccess,
            onFailure: onFailure
        };

        function onSuccess(response) {

            if (response.success) {
                return Vendd.MessageBus.publishAsync(Vendd.Loyalty, new Vendd.Loyalty.Messages.GetLoyaltyNewsDetailSuccess(response.data));
            }

            return Vendd.MessageBus.publishAsync(Vendd.Loyalty, new Vendd.Loyalty.Messages.GetLoyaltyNewsDetailFailure(response));
        }

        function onFailure(response) {
            return Vendd.MessageBus.publishAsync(Vendd.Loyalty, new Vendd.Loyalty.Messages.GetLoyaltyNewsDetailFailure(response));
        }

        Vendd.Service.call(options);
    });

    Vendd.MessageBus.subscribe(Vendd.Loyalty.Messages.CheckByMobile, Vendd.Loyalty, function (envelope) {

        var options = {
            method: 'POST',
            url: 'api/LoyaltyPoints/CheckLoyaltyExistence',
            data: envelope.message.data,
            onSuccess: onSuccess,
            onFailure: onFailure
        };

        function onSuccess(response) {
            
            if (response.data.StatusCode) {
                return  Vendd.MessageBus.publishAsync(Vendd.Loyalty, new Vendd.Loyalty.Messages.CheckByMobileSuccess(response.data));
            }

            return Vendd.MessageBus.publishAsync(Vendd.Loyalty, new Vendd.Loyalty.Messages.CheckByMobileFailure(response));
        };

        function onFailure(response) {
            return Vendd.MessageBus.publishAsync(Vendd.Loyalty, new Vendd.Loyalty.Messages.CheckByMobileFailure(response));
        };

        Vendd.Service.call(options);
    });

    Vendd.MessageBus.subscribe(Vendd.Loyalty.Messages.SendSms, Vendd.Loyalty, function (envelope) {

        var options = {
            method: 'POST',
            url: 'api/LoyaltyPoints/SendSms',
            data: envelope.message.data,
            onSuccess: onSuccess,
            onFailure: onFailure
        };

        function onSuccess(response) {

            if (response.data.StatusCode) {
                return Vendd.MessageBus.publishAsync(Vendd.Loyalty, new Vendd.Loyalty.Messages.SendSmsSuccess(response.data));
            }

            return Vendd.MessageBus.publishAsync(Vendd.Loyalty, new Vendd.Loyalty.Messages.SendSmsFailure(response));
        };

        function onFailure(response) {
            return Vendd.MessageBus.publishAsync(Vendd.Loyalty, new Vendd.Loyalty.Messages.SendSmsFailure(response));
        };

        Vendd.Service.call(options);
    });

    Vendd.MessageBus.subscribe(Vendd.Loyalty.Messages.ValidateSmsCode, Vendd.Loyalty, function (envelope) {

        var options = {
            method: 'POST',
            url: 'api/LoyaltyPoints/ValidateSmsCode',
            data: envelope.message.data,
            onSuccess: onSuccess,
            onFailure: onFailure
        };

        function onSuccess(response) {
            return Vendd.MessageBus.publishAsync(Vendd.Loyalty, new Vendd.Loyalty.Messages.ValidateSmsCodeSuccess(response.data));
        };

        function onFailure(response) {
            return Vendd.MessageBus.publishAsync(Vendd.Loyalty, new Vendd.Loyalty.Messages.ValidateSmsCodeFailure(response));
        };

        Vendd.Service.call(options);
    });

    Vendd.MessageBus.subscribe(Vendd.Loyalty.Messages.SubmitForm, Vendd.Loyalty, function (envelope) {

        var options = {
            method: 'POST',
            url: 'api/LoyaltyPoints/SubmitRegistrationForm',
            data: envelope.message.data,
            onSuccess: onSuccess,
            onFailure: onFailure
        };

        function onSuccess(response) {
            return Vendd.MessageBus.publishAsync(Vendd.Loyalty, new Vendd.Loyalty.Messages.SubmitFormSuccess(response.data));
        };

        function onFailure(response) {
            return Vendd.MessageBus.publishAsync(Vendd.Loyalty, new Vendd.Loyalty.Messages.SubmitFormFailure(response));
        };

        Vendd.Service.call(options);
    });

    Vendd.MessageBus.subscribe(Vendd.Loyalty.Messages.GetPhoneForm, Vendd.Loyalty, function (envelope) {

        var options = {
            method: 'POST',
            url: 'api/LoyaltyPoints/GetPhoneFormModel',
            data: envelope.message.data,
            onSuccess: onSuccess,
            onFailure: onFailure
        };

        function onSuccess(response) {
            return Vendd.MessageBus.publishAsync(Vendd.Loyalty, new Vendd.Loyalty.Messages.GetPhoneFormSuccess(response.data));
        };

        function onFailure(response) {
            return Vendd.MessageBus.publishAsync(Vendd.Loyalty, new Vendd.Loyalty.Messages.GetPhoneFormFailure(response));
        };

        Vendd.Service.call(options);
    });

    Vendd.MessageBus.subscribe(Vendd.Loyalty.Messages.GetRegistrationForm, Vendd.Loyalty, function (envelope) {

        var options = {
            method: 'POST',
            url: 'api/LoyaltyPoints/GetRegistrationFormModel',
            data: envelope.message.data,
            onSuccess: onSuccess,
            onFailure: onFailure
        };

        function onSuccess(response) {
            return Vendd.MessageBus.publishAsync(Vendd.Loyalty, new Vendd.Loyalty.Messages.GetRegistrationFormSuccess(response.data));
        };

        function onFailure(response) {
            return Vendd.MessageBus.publishAsync(Vendd.Loyalty, new Vendd.Loyalty.Messages.GetRegistrationFormFailure(response));
        };

        Vendd.Service.call(options);
    });

    Vendd.MessageBus.subscribe(Vendd.Loyalty.Messages.SubmitContactForm, Vendd.Loyalty, function (envelope) {

        var options = {
            method: 'POST',
            url: 'api/LoyaltyPoints/SubmitContactForm',
            data: envelope.message.data,
            onSuccess: onSuccess,
            onFailure: onFailure
        };

        function onSuccess(response) {
            return Vendd.MessageBus.publishAsync(Vendd.Loyalty, new Vendd.Loyalty.Messages.SubmitContactFormSuccess(response.data));
        };

        function onFailure(response) {
            return Vendd.MessageBus.publishAsync(Vendd.Loyalty, new Vendd.Loyalty.Messages.SubmitContactFormFailure(response));
        };

        Vendd.Service.call(options);
    });

    Vendd.MessageBus.subscribe(Vendd.Loyalty.Messages.ValidateCouponAndSendSms, Vendd.Loyalty, function (envelope) {

        var options = {
            method: 'POST',
            url: 'api/LoyaltyPoints/ValidateCouponAndSendSms',
            data: envelope.message.data,
            onSuccess: onSuccess,
            onFailure: onFailure
        };

        function onSuccess(response) {

            if (response.data.StatusCode) {
                return Vendd.MessageBus.publishAsync(Vendd.Loyalty, new Vendd.Loyalty.Messages.SendSmsSuccess(response.data));
            }

            return Vendd.MessageBus.publishAsync(Vendd.Loyalty, new Vendd.Loyalty.Messages.SendSmsFailure(response));
        };

        function onFailure(response) {
            return Vendd.MessageBus.publishAsync(Vendd.Loyalty, new Vendd.Loyalty.Messages.SendSmsFailure(response));
        };

        Vendd.Service.call(options);
    });
    
    Vendd.MessageBus.subscribe(Vendd.Loyalty.Messages.ApplyCoupon, Vendd.Loyalty, function (envelope) {

        var options = {
            method: 'POST',
            url: 'api/LoyaltyPoints/ApplyCoupon',
            data: envelope.message.data,
            onSuccess: onSuccess,
            onFailure: onFailure
        };

        function onSuccess(response) {
            return Vendd.MessageBus.publishAsync(Vendd.Loyalty, new Vendd.Loyalty.Messages.ApplyCouponSuccess(response.data));
        };

        function onFailure(response) {
            return Vendd.MessageBus.publishAsync(Vendd.Loyalty, new Vendd.Loyalty.Messages.ApplyCouponFailure(response));
        };

        Vendd.Service.call(options);
    });

    Vendd.MessageBus.subscribe(Vendd.Loyalty.Messages.ClearCoupon, Vendd.Loyalty, function (envelope) {

        var options = {
            method: 'POST',
            url: 'api/LoyaltyPoints/ClearCoupon',
            data: envelope.message.data,
            onSuccess: onSuccess,
            onFailure: onFailure
        };

        function onSuccess(response) {
            return Vendd.MessageBus.publishAsync(Vendd.Loyalty, new Vendd.Loyalty.Messages.ClearCouponSuccess(response.data));
        };

        function onFailure(response) {
            return Vendd.MessageBus.publishAsync(Vendd.Loyalty, new Vendd.Loyalty.Messages.ClearCouponFailure(response));
        };

        Vendd.Service.call(options);
    });

    Vendd.MessageBus.subscribe(Vendd.Loyalty.Messages.InviteFriends, Vendd.Loyalty, function (envelope) {

        var options = {
            method: 'GET',
            url: 'api/InviteFriend/SubmitLoyaltyFriendRequests',
            data: envelope.message.data,
            onSuccess: onSuccess,
            onFailure: onFailure
        };

        function onSuccess(response) {
            return Vendd.MessageBus.publishAsync(Vendd.Loyalty, new Vendd.Loyalty.Messages.InviteFriendsSuccess(response));
        };

        function onFailure(response) {
            return Vendd.MessageBus.publishAsync(Vendd.Loyalty, new Vendd.Loyalty.Messages.InviteFriendsFailure(response.responseJSON));
        };

        Vendd.Service.call(options);
    });

    return Vendd;

})(Vendd || {});